import {
	FETCH_ENHANCEMENTS_BEGIN,
	FETCH_ENHANCEMENTS_SUCCESS,
	FETCH_ENHANCEMENTS_FAILURE
} from '../actions/fetchEnhancements'

import merge from 'lodash/merge'

const initialState = {
	enhancements: [],
	loading: false,
	error: null,
}

export default function fetchEnhancementsReducers(state = initialState, action) {
	switch(action.type) {
		case FETCH_ENHANCEMENTS_BEGIN:
			// Request begin: set loading true
			return {
				...state,
				loading: true,
				error: null
			}

		case FETCH_ENHANCEMENTS_SUCCESS:
			// Request success: set loading false, set config data
			return {
				...state,
				loading: false,
				error: null,
				enhancements: merge({}, state.enhancements, action.payload)
			}

		case FETCH_ENHANCEMENTS_FAILURE:
			// Request failed: set loading false, save & display error
			return {
				...state,
				loading: false,
				error: action.payload.error,
				enhancements: [],
			}

		default:
			return state;
	}
}



// WEBPACK FOOTER //
// ./src/reducers/fetchEnhancementsReducers.js